import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import Marquee from "react-fast-marquee";

export const AuthShell = ({ children, quote, author }) => (
  <div className="min-h-screen grid lg:grid-cols-2 bg-paper">
    <div className="hidden lg:flex flex-col justify-between bg-obsidian text-white p-12 border-r-2 border-obsidian relative overflow-hidden">
      <Link to="/" data-testid="auth-brand-logo" className="flex items-center gap-2 font-display font-black text-xl">
        <img src="/logo.png" alt="ShipZilla logo" className="w-9 h-9 rounded-xl" />
        SHIPZILLA
      </Link>
      <div>
        <p className="font-display font-black tracking-tight text-5xl xl:text-6xl leading-[1.02]">
          {quote}
        </p>
        <p className="mt-6 text-sm font-mono text-sky-300 uppercase tracking-[0.2em]">{author}</p>
      </div>
      <div className="border-t border-white/10 pt-6">
        <Marquee speed={25} gradient={false} className="text-zinc-500 font-mono text-xs uppercase tracking-widest">
          {["Delhi", "Mumbai", "Bengaluru", "Jaipur", "Kochi", "Guwahati", "Surat", "Indore"].map((c) => (
            <span key={c} className="mx-6">● {c} 19,000+ pincodes</span>
          ))}
        </Marquee>
      </div>
    </div>
    <div className="flex items-center justify-center p-6 sm:p-12">
      <div className="w-full max-w-md">{children}</div>
    </div>
  </div>
);
